import React from 'react'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'
import { useAsync } from 'react-use'

import { faSignal } from '@fortawesome/pro-solid-svg-icons'
import clsx from 'clsx'

import { linkClasses } from 'components/navigation/styles'

import statusPage from 'lib/statusPage'

const IndicatorColorMap = {
  critical: 'bg-error-default',
  major: 'bg-error-alternative',
  minor: 'bg-warning-muted',
  none: 'bg-success-default'
} as const

export const StatusLink = () => {
  const { value } = useAsync(async () => {
    const { status } = await statusPage.api.getStatus()
    const { indicator } = status

    return { indicator }
  }, [])

  // If no value is present, render nothing
  if (!value) return null

  const { indicator } = value

  return (
    <a className={linkClasses} href='https://status.infura.io/' rel='noopener noreferrer' target='_blank'>
      <span className='relative inline-flex items-center'>
        <FontAwesomeIcon className='fa-fw' icon={faSignal} />
        {/* Blinking Status Beacon Beacon */}
        <span className='absolute -right-1 flex items-center justify-center '>
          {/* Marker 1 */}
          <span
            className={clsx(
              'inline-flex h-2 w-2 animate-ping rounded-full opacity-75',
              IndicatorColorMap[indicator] || 'bg-warning'
            )}
          />
          {/* Marker 2 */}
          <span
            className={clsx('absolute inline-flex h-2 w-2 rounded-full', IndicatorColorMap[indicator] || 'bg-gray-300')}
          />
        </span>
      </span>
      <span className='text-sm font-medium'>Status</span>
    </a>
  )
}
